const config = {
    apiKey: "AIzaSyCntPK7yaPhyShl7LHi2hd3t2xmu0jCjEQ",
    authDomain: "carbon-intensity-service.firebaseapp.com",
    databaseURL: "https://carbon-intensity-service.firebaseio.com"
};

export default config;